/* eslint-disable no-unused-vars */
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'

import { store } from './build_a_box_v2/store/store'
import { I18nextProvider } from 'react-i18next'
import { initi18n } from './build_a_box_v2/utils/i18n'
import { ProductsDataProvider } from './build_a_box_v2/contexts/productsData.context'
import { StepHandlerProvider } from './build_a_box_v2/contexts/stepHandler.context'
import { NextButtonAvailabilityProvider } from './build_a_box_v2/contexts/nextButtonAvailability.context'

import App from './build_a_box_v2/containers/App'

const jsJooneBuildABox = () => document.getElementById('js-joone-build-a-box')

const initApp = () => {
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <I18nextProvider i18n={initi18n()}>
            <ProductsDataProvider>
              <StepHandlerProvider>
                <NextButtonAvailabilityProvider>
                  <App />
                </NextButtonAvailabilityProvider>
              </StepHandlerProvider>
            </ProductsDataProvider>
          </I18nextProvider>
        </BrowserRouter>
      </Provider>
    </React.StrictMode>,
    jsJooneBuildABox()
  )
}

export const initBuildABoxPage = () => {
  if (!jsJooneBuildABox()) return

  window.dataLayer = window.dataLayer || []
  initApp()
}
